import { useGetCurrentAgentsPresenter, useUpdateAgentLoader } from '@/pages/agents/hooks';
import { isImageProcessing } from '@/state/presenters/presenters';
import theme from '@/theme';
import { AgentStatus, IAgent, VideoType } from '@d-id/types';
import styled from '@emotion/styled';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { useRecoilValue } from 'recoil';
import { AgentTabs } from './AgentTabs';
import { PlaygroundContainer } from './playground/PlaygroundContainer';

const PresentersDisplayContainer = styled.div`
    display: flex;
    flex-direction: row;
    height: calc(100% - 8rem);
    box-sizing: border-box;
    background: ${theme.colors.white};
`;

const WizardContainer = styled.div`
    display: flex;
    justify-content: center;
    flex: 60%;
    gap: 1rem;
    overflow-y: auto;
`;

interface Props {
    agent: IAgent;
}

export const PresentersContainer = observer(({ agent }: Props) => {
    const isUploadingImage = useRecoilValue(isImageProcessing);
    const { showAgentLoader } = useUpdateAgentLoader();
    const presenter = useGetCurrentAgentsPresenter(!agent.id || agent.status === AgentStatus.Created);

    useEffect(() => {
        isUploadingImage && showAgentLoader();
    }, [isUploadingImage]);

    return (
        <PresentersDisplayContainer>
            <WizardContainer>
                <AgentTabs agentId={agent.id} presenter={presenter} />
            </WizardContainer>
            <PlaygroundContainer enableStitchSelection={presenter?.type === VideoType.TALK} agentId={agent.id} />
        </PresentersDisplayContainer>
    );
});
